const SUCCESS = 'success';
const ERROR = 'error';

export class Notification {

    constructor() {
        this.notifications = [];
    }

    any() {
        return this.notifications.length > 0;
    }

    get() {
        return this.notifications;
    }

    set(notifications) {
        this.notifications = notifications;
    }

    add(notification) {
        this.notifications.push(notification);
    }

    success(message) {
        this.add({
            type: SUCCESS,
            text: message
        });
    }

    error(message) {
        this.add({
            type: ERROR,
            text: message
        });
    }

    clear() {
        this.set([]);
    }
}
